import User, { intercomLogout } from '@mentimeter/user';

export const logout = () => {
  intercomLogout();
  User.logout('/');
};
